// extracted by mini-css-extract-plugin
export default {"degree":"mNE4EFv89Qvnt_v7lWbm"};